import React from 'react';

export default function SmsConsentPreviewPage() {
  return (
    <div style={{ minHeight: '100vh', background: '#0F1923', fontFamily: 'Arial, sans-serif' }}>

      {/* Header */}
      <div style={{ background: '#0F1923', borderBottom: '3px solid #4A7EB5', padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <div style={{ color: '#fff', fontWeight: 900, fontSize: 16 }}>McMullen Browne Development LLC</div>
          <div style={{ color: '#4A7EB5', fontSize: 11, letterSpacing: 2, textTransform: 'uppercase' }}>Employee Onboarding</div>
        </div>
        <div style={{ color: '#8FA8C0', fontSize: 12 }}>Step 6 of 8</div>
      </div>

      <div style={{ maxWidth: 720, margin: '0 auto', padding: '32px 16px' }}>

        {/* Notice Banner */}
        <div style={{ background: 'rgba(74,126,181,0.12)', border: '1px solid #4A7EB5', borderRadius: 10, padding: '12px 16px', marginBottom: 28, display: 'flex', gap: 10, alignItems: 'flex-start' }}>
          <span style={{ fontSize: 18, flexShrink: 0 }}>ℹ️</span>
          <span style={{ color: '#8FA8C0', fontSize: 13, lineHeight: 1.6 }}>
            <strong style={{ color: '#fff' }}>Public Consent Preview</strong> — This page shows the exact SMS consent disclosure presented to McMullen Browne Development LLC employees during the employee onboarding process. It is provided for compliance review purposes. Actual opt-in occurs through a secure, personalized onboarding link sent to each employee.
          </span>
        </div>

        <h2 style={{ color: '#fff', fontSize: 22, fontWeight: 800, marginBottom: 16 }}>Agreements &amp; Consent</h2>

        {/* SMS Consent Box — exact replica of onboarding acknowledgments step */}
        <div style={{ background: '#1A2B3C', border: '2px solid #4A7EB5', borderRadius: 10, padding: 20, marginBottom: 24 }}>
          <div style={{ color: '#4A7EB5', fontWeight: 700, fontSize: 13, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12 }}>SMS Notifications Consent</div>

          <div style={{ color: '#8FA8C0', fontSize: 13, lineHeight: 1.8 }}>
            <p style={{ marginBottom: 10 }}>
              McMullen Browne Development LLC sends internal SMS notifications to employees to alert them of new customer leads, job updates, and schedule changes. Message frequency varies based on business activity — typically 1–20 messages per day.
              <strong style={{ color: '#fff' }}> Message and data rates may apply.</strong> You may reply <strong style={{ color: '#fff' }}>STOP</strong> at any time to opt out or <strong style={{ color: '#fff' }}>HELP</strong> for assistance.
            </p>
            <p style={{ marginBottom: 10 }}>
              For help, contact: <span style={{ color: '#4A7EB5' }}>jarvis@mcmullenbrowne.com</span> | (302) 332-7573
            </p>
            <p style={{ marginBottom: 10 }}>
              Mobile numbers and SMS consent are <strong style={{ color: '#fff' }}>never shared with third parties</strong> for marketing or promotional purposes.
            </p>
            <p style={{ marginBottom: 10 }}>
              Consent is <strong style={{ color: '#fff' }}>not a condition of employment</strong>. Employees who decline SMS consent will receive notifications through alternative means.
            </p>
            <p>
              <a href="https://mcmullenbrownecrm.com/terms" target="_blank" rel="noreferrer" style={{ color: '#4A7EB5' }}>Terms &amp; Conditions</a>
              {' · '}
              <a href="https://mcmullenbrownecrm.com/privacy" target="_blank" rel="noreferrer" style={{ color: '#4A7EB5' }}>Privacy Policy</a>
            </p>
          </div>

          {/* Checkbox — shown as checked for preview */}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginTop: 16, background: '#0F1923', borderRadius: 8, padding: '12px 14px', border: '1px solid #2D4259' }}>
            <div style={{ width: 16, height: 16, background: '#4A7EB5', borderRadius: 3, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: 2 }}>
              <span style={{ color: '#fff', fontSize: 11, fontWeight: 900 }}>✓</span>
            </div>
            <span style={{ fontSize: 13, color: '#cbd5e1', lineHeight: 1.6 }}>
              I consent to receive internal SMS notifications from McMullen Browne Development LLC at my mobile number.
            </span>
          </div>
          <div style={{ color: '#8FA8C0', fontSize: 11, marginTop: 6, marginLeft: 26 }}>
            ↑ Employee must actively check this box. It is unchecked by default. Consent timestamp and IP address are recorded at the moment of opt-in.
          </div>
        </div>

        {/* How It Works */}
        <div style={{ background: '#1A2B3C', border: '1px solid #1E3A5F', borderRadius: 10, padding: 20, marginBottom: 24 }}>
          <div style={{ color: '#4A7EB5', fontWeight: 700, fontSize: 13, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 14 }}>How Opt-In Works</div>
          <div style={{ color: '#8FA8C0', fontSize: 13, lineHeight: 1.9 }}>
            <div style={{ display: 'flex', gap: 10, marginBottom: 8 }}>
              <span style={{ color: '#4A7EB5', fontWeight: 800, flexShrink: 0 }}>1.</span>
              <span>Administrator creates a new employee record in the CRM and sends an onboarding invitation via email.</span>
            </div>
            <div style={{ display: 'flex', gap: 10, marginBottom: 8 }}>
              <span style={{ color: '#4A7EB5', fontWeight: 800, flexShrink: 0 }}>2.</span>
              <span>Employee receives an email with a secure, single-use personalized link to the onboarding portal.</span>
            </div>
            <div style={{ display: 'flex', gap: 10, marginBottom: 8 }}>
              <span style={{ color: '#4A7EB5', fontWeight: 800, flexShrink: 0 }}>3.</span>
              <span>During the <strong style={{ color: '#fff' }}>Agreements &amp; Consent</strong> step (shown above), the employee is presented with the full SMS disclosure.</span>
            </div>
            <div style={{ display: 'flex', gap: 10, marginBottom: 8 }}>
              <span style={{ color: '#4A7EB5', fontWeight: 800, flexShrink: 0 }}>4.</span>
              <span>The employee must <strong style={{ color: '#fff' }}>actively check</strong> the unchecked consent checkbox to opt in. SMS consent is never pre-checked or assumed.</span>
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <span style={{ color: '#4A7EB5', fontWeight: 800, flexShrink: 0 }}>5.</span>
              <span>The date, time, and IP address of consent are recorded at the moment of opt-in and retained in company records.</span>
            </div>
          </div>
        </div>

        {/* Legal Links */}
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
          <a href="https://mcmullenbrownecrm.com/privacy" target="_blank" rel="noreferrer"
            style={{ color: '#4A7EB5', fontSize: 13, textDecoration: 'none', background: 'rgba(74,126,181,0.1)', border: '1px solid #4A7EB5', borderRadius: 8, padding: '8px 16px', display: 'inline-block' }}>
            Privacy Policy →
          </a>
          <a href="https://mcmullenbrownecrm.com/terms" target="_blank" rel="noreferrer"
            style={{ color: '#4A7EB5', fontSize: 13, textDecoration: 'none', background: 'rgba(74,126,181,0.1)', border: '1px solid #4A7EB5', borderRadius: 8, padding: '8px 16px', display: 'inline-block' }}>
            Terms &amp; Conditions →
          </a>
        </div>

      </div>
    </div>
  );
}
